import { Link } from "react-router-dom";
import ContentPage from "../../Content";

function FdrPage(){
    return (
        <>
            <ContentPage>
                <div class="page-header flex-wrap">
                        <div class="header-right d-flex flex-wrap mt-md-2 mt-lg-0">
                            <div class="d-flex align-items-center">
                                <a href="#">
                                    <p class="m-0 pr-3">Gestion Des Etats Financiers</p>
                                </a>
                                <a class="pl-3 mr-4" href="#">
                                    <p class="m-0">Page Fond De Roulement</p>
                                </a>
                            </div>
                            {/* <button type="button" class="btn btn-primary mt-2 mt-sm-0 btn-icon-text">
                            <i class="mdi mdi-plus-circle"></i> Add Prodcut </button> */}
                        </div>
                        {/* <div class="header-left">
                            <Link class="btn btn-primary mb-2 mb-md-0 mr-2" to="/parametres/add-distributeur"> Ajouter un distributeur</Link>
                            <button class="btn btn-outline-primary mb-2 mb-md-0"> Import documents </button>
                        </div> */}
                
                </div>

                
              <div class="col-lg-12 grid-margin stretch-card">
                <div class="card">
                  <div class="card-body">
                    <h4 class="card-title">FONDS DE ROULEMENTS</h4>
                    <div class="table-responsive">
                      <table class="table table-striped">
                        <thead>
                          <tr>
                            <th>DESIGNATION</th>
                            <th></th>
                            <th></th>
                            <th></th>
                            <th></th>
                            <th></th>
                            <th className="text-center">ACTIONS</th>
                          </tr>
                        </thead>
                        <tbody>
               
                          <tr>                            
                                <td className="fw-bold">Fonds de Roulement des sites</td>
                                <td class="py-1"></td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td className="text-center">
                                <Link class="btn btn-primary" to="/fonds-roulements-sites"> Acceder </Link>
                                </td>
                          </tr>

                          <tr>                            
                                <td className="fw-bold">Fons de Roulement des GesSites</td>
                                <td class="py-1"></td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td className="text-center">
                                <Link class="btn btn-primary" to="/fonds-roulements-gesites"> Acceder </Link>
                                </td>
                          </tr>

                          {/* <tr>                            
                                <td className="fw-bold">Fons de Roulement des Commerciaux</td>
                                <td class="py-1"></td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td className="text-center">
                                <Link class="btn btn-primary" to="/fonds-roulements-commerciaux"> Acceder </Link>
                                </td>
                          </tr> */}

                         
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>


            </ContentPage>
        </>
    )
}

export default FdrPage;